import { useEffect, useState } from "react";
import { get, patchRequest } from "../../../http/api";

export default function StatsSection() {
  const [role, setRole] = useState(null);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  /* FETCH STATS */
  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await get("profile/stats");
      setRole(res.data.role);
      setStats(res.data.stats || {});
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    setStats({ ...stats, [e.target.name]: e.target.value });
    setSuccess(false);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await patchRequest("profile/stats", stats);
      setSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!role) return null;

  return (
    <section className="settings-card">
      <h3>Stats</h3>
      <p className="settings-hint">
        Ces statistiques améliorent la crédibilité de ton profil
      </p>

      {/* ATHLETE */}
      {role === "athlete" && (
        <>
          <label>Saisons jouées</label>
          <input
            type="number"
            name="seasons"
            value={stats.seasons || ""}
            onChange={handleChange}
          />

          <label>Matchs joués</label>
          <input
            type="number"
            name="matches_played"
            value={stats.matches_played || ""}
            onChange={handleChange}
          />

          <label>Buts / Points (optionnel)</label>
          <input
            type="number"
            name="goals_points"
            value={stats.goals_points || ""}
            onChange={handleChange}
          />
        </>
      )}

      {/* CLUB */}
      {role === "club" && (
        <>
          <label>Saisons actives</label>
          <input
            type="number"
            name="active_seasons"
            value={stats.active_seasons || ""}
            onChange={handleChange}
          />

          <label>Joueurs actuels</label>
          <input
            type="number"
            name="current_players"
            value={stats.current_players || ""}
            onChange={handleChange}
          />

          <label>Titres remportés (optionnel)</label>
          <input
            type="number"
            name="titles"
            value={stats.titles || ""}
            onChange={handleChange}
          />
        </>
      )}

      {/* BRAND */}
      {role === "brand" && (
        <>
          <label>Campagnes lancées</label>
          <input
            type="number"
            name="campaigns"
            value={stats.campaigns || ""}
            onChange={handleChange}
          />

          <label>Athlètes collaborés</label>
          <input
            type="number"
            name="athletes"
            value={stats.athletes || ""}
            onChange={handleChange}
          />
        </>
      )}

      {/* LAWYER */}
      {role === "lawyer" && (
        <>
          <label>Dossiers traités</label>
          <input
            type="number"
            name="cases_handled"
            value={stats.cases_handled || ""}
            onChange={handleChange}
          />

          <label>Années d’expérience</label>
          <input
            type="number"
            name="experience_years"
            value={stats.experience_years || ""}
            onChange={handleChange}
          />
        </>
      )}

      <div className="settings-actions">
        <button
          className="btn primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "Enregistrement..." : "Enregistrer"}
        </button>

        {success && <span className="success-msg">✔ Sauvegardé</span>}
      </div>
    </section>
  );
}